export function useSiteMeta() {
  const settingsStore = typeof useSiteSettingsStore === 'function' ? useSiteSettingsStore() : null
  const { API_ENDPOINTS, BASE_URL } = useApiEndpoints()
  return useAsyncData('site-meta', () => $fetch(BASE_URL + API_ENDPOINTS.public.site.settings), {
    server: true,
    lazy: false,
    transform: (data: any) => {
      try { settingsStore?.setAll?.(data) } catch (_) {}
      return data
    },
    default: () => ({ title: '', description: '', logo: null, supportEmail: '', supportPhone: '', socials: {} as any })
  })
}
